import template from './syncSchedule.html';
import controller from './syncSchedule.controller';

let syncScheduleComponent = {
  restrict: 'E',
  bindings: {
    agentConfig: '='
  },
  template,
  controller,
  controllerAs: 'vm'
};

export default syncScheduleComponent;



// WEBPACK FOOTER //
// ./app/components/syncSchedule/syncSchedule.component.js